import { translate } from 'components/shared/internationalization'

export const MAX_FILE_SIZE = 2 * 1024 * 1024 // 2 MB
export const validTypes = ['.docx']
export const MAX_FILENAME_LENGTH = 255
export const MAX_TEMPLATE_TITLE_LENGTH = 255
export const MAX_TEMPLATE_COMPANY_NAME_LENGTH = 120
export const MAX_TEMPLATE_DESCRIPTION_LENGTH = 1000
export const MAX_WRITING_STYLE_DESCRIPTION_LENGTH = 15000
export const WARNING_TYPE_SPELLING = 'spelling'
export const WARNING_TYPE_PROFANITY = 'profanity'
export const TOAST_TYPE_SUCCESS = 'success'
export const TOAST_TYPE_FAIL = 'fail'
export const MAX_TEMPLATE_TITLE_LENGTH_IN_SIDEBAR = 35
export const TEMPLATE_OVERLAY_OPTIONS = {
    OPTION_DEFAULT : 1,
    OPTION_EDIT : 2,
    OPTION_DOWNLOAD : 3,
    OPTION_DELETE : 4
}
export const MAX_TEMPLATE_TITLE_DESCTIPTION_LENGTH = 200
export const MAX_TEMPLATE_TITLE_DESCTIPTION_LENGTH_IN_SIDEBAR = 120
export const MAX_REMINDERS = 3
export const MAX_DAYS = 365
export const MAX_WEEKS = 52
export const MAX_MONTHS = 12
export const REMINDER_OPTIONS = [
    { label: translate('ON_DUE_DATE_LABEL'), value: 'due_date' },
    { label: translate('REMINDER_DAYS_LABEL'), value: 'days' },
    { label: translate('REMINDER_WEEKS_LABEL'), value: 'weeks' },
    { label: translate('REMINDER_MONTHS_LABEL'), value: 'months' }
]
export const DAYS_DEFAULT_VALUE = 3
export const REMINDER_DEFAULT_VALUE = 3
export const REMINDER_MIN_VALUE = 1
export const MINUTES_TEMPLATES_DILIGENT_TEMPLATE_TITLE = 'Legacy Diligent template'
export const MINUTES_TEMPLATES_DILIGENT_ACADEMY_TEMPLATE_TITLE = 'Board Meeting Minutes template'
export const MINUTES_TEMPLATES_DILIGEN_ACADEMY_TEMPLATE_DESCRIPTION = 'Diligent Academy-based template for organized meeting records: capturing discussions, decisions, and action items.'
export const MINUTES_TEMPLATES_DILIGENT_TEMPLATE_DESCRIPTION = 'Template in the legacy style with minimal formatting.'
export const ACTION_UNICODE_PATTERN = new RegExp("^[\\p{L}\\p{M}0-9.#$%^&* ']+$", 'u')
export const ACTION_ASCII_PATTERN = /^[-A-Za-z0-9@.#$%^&* ']+$/

export const POLLING_INTERVAL = 30000
export const TOAST_DURATION = 5000
export const PLATFORM_OPTION  = {
    BOARDS: 'boards',
    BOARD_EFFECT: 'boardeffect',
    BOARDIOS: 'boardios',
}

// Allowed users who can view generated AI writing styles
export const ALLOWED_WRITING_STYLE_VIEWERS = [
    'veprasad@diligent.com',
    'RRasheeda@diligent.com',
    'aiqbal@diligent.com',
    'yaagarwal@diligent.com',
    'aprabhuswamy@diligent.com',
    'asali@diligent.com',
    'maahuja@diligent.com',
    'amaheswaran@diligent.com',
    'csadasivan@diligent.com',
    'mpothumsetty@diligent.com',
    'tlokhande@diligent.com',
    'msaibalwar@diligent.com',
    'cmcgowan@diligent.com',
    'gdaroczi@diligent.com',
    'ghyland@diligent.com'
]

export const MAX_ATTENDANCE_CHIPS = 100
export const TOOLTIP_AUTO_CLOSE_DELAY = 3000

// Request lifecycle status constants (used by minutes UI components)
export const REQUEST_STATUS_IDLE = 'idle'

export const ATTENDANCE_MODE = {
    REMOTE: 'remote',
    IN_PERSON: 'in_person'
}

export const ATTENDANCE_STATUS = {
    PRESENT: 'present',
    ATTENDING: 'attending',
    APOLOGIES: 'apologies'
}
export const ATTENDEE_SECTIONS = {
    INVITED: 'invitedAttendees',
    PRESENT: 'presentAttendees',
    ABSENT: 'absentAttendees'
}

export const SECTION_TYPES = {
    INVITED: 'invited',
    PRESENT: 'present',
    ABSENT: 'absent'
}

export const API_ATTENDEE_STATE_KEYS = {
    INVITED: 'apiInvitedAttendees',
    PRESENT: 'apiPresentAttendees',
    ABSENT: 'apiAbsentAttendees'
}

